/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab.ts";

function getPutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabUrl(
  courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/selective-process-tab` as const,
  };
  return res;
}

/**
 * @description Atualiza status, tipo de admissão, datas de vestibular e entrevista, flags de presença e aprovação de documentação, motivo de rejeição e notas do processo seletivo. As notas são informadas na escala 0–10 e armazenadas divididas por 10. Requer permissão de empresa sobre a matrícula. **(Requer Authorization para autenticação)**
 * @summary Salva os dados do processo seletivo de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/selective-process-tab}
 */
export async function putApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab(
  courseRegistrationId: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabPathParams["courseRegistrationId"],
  data?: PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationResponse,
    ResponseErrorConfig<
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab400
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab401
      | PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTab500
    >,
    PutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1CourseregistrationEnrollmentCourseregistrationidSelectiveProcessTabUrl(
      courseRegistrationId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
